/* stylelint-disable selector-type-no-unknown */

import styled, { css } from 'styled-components';

import * as vr from 'core/styles/variables';

import { baseInputStyles } from 'pods/forms/components/inputs/Text/Text.style';

export const FundsAutocompleteContainer = styled.div<{
	hasError?: boolean;
	disabled?: boolean;
}>`
	display: flex;
	align-items: center;

	.formBuilder__fundsAutocomplete {
		${props => baseInputStyles(props)}
		max-width: unset;
		border: none;
		padding: 0;

		&__control {
			padding: 8px 10px;
			transition: none;
			cursor: text;

			${({ hasError, disabled }) =>
				!disabled &&
				css`
					border: 1px solid
						${hasError ? vr.formfieldErrorColor : vr.formfieldBorderColor};

					&:hover {
						outline: none;
						border: 1px solid
							${hasError
								? vr.formfieldErrorColor
								: vr.formfieldOnHoverBorderColor};
						box-shadow: 0 0 0 1px
							${hasError
								? vr.formfieldErrorColor
								: vr.formfieldOnHoverBorderColor};
					}

					&--is-focused {
						padding: 8px 10px;
						outline: none;
						border: 1px solid
							${hasError
								? vr.formfieldErrorColor
								: vr.formfieldBorderColorFocus} !important;
						box-shadow: 0 0 0 1px
							${hasError
								? vr.formfieldErrorColor
								: vr.formfieldBorderColorFocus} !important;
					}
				`}

			&--is-disabled {
				border: 1px solid ${vr.radioCheckboxDefault} !important;
			}
		}

		&__value-container {
			padding: 0 4px;
		}

		&__menu {
			color: ${vr.formfieldColor};
		}
	}
`;

export const MenuList = styled.div`
	overflow: auto;
	max-height: 300px;
`;

export const Option = styled.div``;
